export default {
    privacyAgreement: {
      privacy: `深大文德教育科技（深圳）有限公司隐私条款
      更新日期：【2021】年【12】月【2】日
      生效日期：【2021】年【12】月【2】日
      
      　　深大文德教育科技（深圳）有限公司（以下简称“深大文德”）深知个人信息对您的重要性，会尽力保护您的个人信息安全。深大文德致力于维护您对深大文德的信任，恪守以下原则保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、必要性原则、确保安全原则、公开透明原则等。同时，深大文德承诺依法采取相应的安全保护措施来保护您的个人信息。
      　　请您在注册前，仔细阅读并确认本《隐私条款》。本《隐私条款》是深大文德统一使用的一般性隐私条款，适用于深大文德所有产品和服务。对应具体的产品（或服务），深大文德收集和使用您的信息的目的、方式和范围将通过相应的产品（或服务）协议、授权书等方式向您明示，并取得您的授权或同意。上述文件与本《隐私条款》共同构成深大文德与您之间达成的完整隐私条款，两者如有不一致之处，以相应的产品（或服务）协议或授权书的约定为准。
      　　本《隐私条款》将帮助您了解以下内容：
      　　1．深大文德如何收集和使用您的个人信息；
      　　2．深大文德如何使用 Cookie和同类技术；
      　　3．深大文德如何共享您的个人信息；
      　　4．深大文德如何保护您的个人信息；
      　　5．您控制个人信息的权利；
      　　6．本协议如何更新；
      7．如何联系深大文德；
      
      一、深大文德如何收集和使用您的个人信息
      　　个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。个人信息包括姓名、出生日期、身份证件号码、个人生物识别信息、通信通讯联系方式、住址、账户信息、财产状况、行踪轨迹等。其中一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的信息为个人敏感信息，主要包括：身份证件号码、个人生物识别信息、银行账号、征信信息、财产信息、交易信息、行踪轨迹、健康生理信息等。
      　　（一）深大文德收集和使用个人信息的原则
      　　深大文德收集使用您的个人信息将遵循合法、正当、必要的原则，按照法律法规要求以及业务需要收集您的个人信息，不会收集与业务无关的信息或采取不正当方式收集信息。
      　　（二）深大文德收集和使用个人信息的目的
      　　深大文德收集您的个人信息，目的在于依法合规的为您提供优质的产品（或服务），该等信息对于充分履行您和深大文德之间的合约很有必要，并使得深大文德能够遵守相关法律义务，具体可能包括：
      　　1. 为保护您的账户安全，对您的身份进行识别、验证等；
      　　2. 为您提供产品（或服务）所必须；
      　　3. 为改善产品（或服务）、提升客户体验；
      　　4. 为履行法定义务（如反洗钱义务）；
      　　5. 经您许可的其他用途。
      　　（三）深大文德收集个人信息的方式
      　　1.深大文德为您提供服务时，您主动向深大文德提供的个人信息；
      　　2.深大文德为您提供服务过程中形成的与服务相关的信息；
      3.经您许可的其他方式。
      （四）深大文德具体收集的个人信息：
      美德少年：
      用户在【注册】时，需要填写【账号、账号名、学校、年级、班级、地址】进行注册。【账号和账号名】由用户自行设置，作为登录的验证信息。【学校和地址】作为区分学校的依据，以防有学校重名，所以需要地区做范围验证，学校信息的收集用于用户校内排名等。【学校、年级和班级】的信息收集，用于学校服务，方便学校老师进行管理。【地址】以用户自主填写的信息为准，深大文德不会去定位和获取用户的位置。
      若用户使用【登录】功能/服务时，我们将获取用户的【账号、账户名】信息，以便下次快速登录。
      根据国家相关规定，有【聊天】舆论功能的APP，需要获取用户源网络地址、端口号、登录时间、目的网络地址、端口号、URL的信息，所以在美德少年中【注册】时，美德少年会获取以上信息。
      若用户使用【分享】功能时，将直接跳转入第三方平台，我们会使用第三方SDK收集、使用你的个人信息。例如为使您可以使用微信分享功能，第三方合作伙伴可能会收集个人常用设备信息、网络状态等。除此之外，美德少年不会主动共享或转让您的个人信息至本公司外的第三方。存在其他共享或转让您的个人信息或您需要我们将您的个人信息共享或转让至本公司外的第三方情形时，我们会直接或确认第三方征得您对上述行为的明示同意。此外，我们会对对外提供信息的行为进行风险评估。
      美德少年会使用本地缓存技术，保存用户注册的账号信息，用于登录及后期请求后台数据。
      美德少年在【登录】时会获取用户的【存储权限】，用以储存名为Cookie的小数据文件。Cookie通常包含标识符、站点名称、以及一些号码和字符。例如，借助Cookie，美德少年能够存储用户的注册账号、名字等注册数据，用户可以进行快速登录。我们不会将Cookie用于本隐私条款外的任何用途。用户可以根据自己的偏好管理和删除Cookie，如果用户清除移动设备上保存的所有Cookie，则需要在下一次使用美德少年时，重新输入相关信息。
      在本协议中，我们专门针对14岁以下被监护人用户制定了《儿童个人信息保护指引》，请监护人您特别关注。14岁以下儿童的个人信息属于个人敏感信息，为确保儿童个人信息的安全，我们存储儿童个人信息不会超过为现实收集、使用儿童个人目的所必需的最小期限。
      用户在使用【绑定家长】功能/服务时，我们会获取用户的的【头像、账户名、账号】，展示给美德少年家长端，用于给美德少年家长端用户确定、验证绑定对象是否有误。
      用户在使用【情景教室】功能/服务中获得的【成绩】，我们将会把【成绩】信息共享给与此用户绑定的“美德少年家长端”的家长账号。若需要把【成绩】信息提供给对用户有教养义务的其他第三方，我们会在此前对用户进行提示和征得同意。
      用户可以通过点击【修改设置】-【注销账号】，在满足账号注销的条件下选择账号注销；账号注销后，除法律明确规定必须由我们保留的个人信息外，用户的个人信息将会从美德少年移除，保障您撤回对个人信息使用的同意及注销帐号的权利。
      
      美德少年家长端：
      在美德少年少年家长端中【注册】时，需要填写【账户名、手机号码、密码】，如果用户拒绝提供上诉信息，将无法注册美德少年家长端账户。【手机号和密码】作为登录的验证消息。
      美德少年家长端会使用本地缓存技术，保存用户注册的账号信息，用于登录及后期请求后台数据。
      用户在使用【绑定学生】功能/服务时，我们会获取用户的【账户名、手机号码】，展示给美德少年用户，用于给美德少年用户确定、验证绑定对象是否有误。
      用户可以通过点击【设置】-【注销账号】，在满足账号注销的条件下选择账号注销；账号注销后，除法律明确规定必须由我们保留的个人信息外（如您在美德少年交易相关的信息），用户的个人信息将会从美德少年移除。
      
      
      　　（五）深大文德如何使用个人信息
      　　1.在向您提供深大文德的产品或服务，并为改进这些产品或服务时使用。
      　　2.在深大文德向您提供服务期间，您授权深大文德持续收集和使用您的信息。在您注销服务时，我们将停止收集您相关的个人信息。
      　　3.为提升您的产品或服务体验，或为防范风险，深大文德会对服务使用情况进行汇总、统计分析、加工，但这些信息不会包含您的任何身份识别信息。
      　　4.为了使您知悉使用深大文德的产品或服务的情况，或使您进一步了解深大文德服务，深大文德会向您发送服务状态通知以及相关产品或服务的商业性信息。如您不希望接受商业性信息，您有权退订，并要求深大文德停止为此项用途使用您的信息。
      5.将您的个人信息用于法律允许的其它用途。
      6.为了在本指引下收集您的信息，或者向您提供服务、优化我们的服务以及保障你的帐号安全，我们将需要向您索取相关的权限，只有经过您明确同意后方视为获得授权。我们获得具体某一项敏感权限并不代表我们必然会收集您的相关信息；即使我们已经获得敏感权限，也仅在必要时、根据本指引来收集、使用您的相关信息。
      
      二、深大文德如何使用Cookie和同类技术
      　　（一）Cookie
      　　为确保网站正常运转，深大文德会在您的计算机或移动设备上存储名为 Cookie 的小数据文件。Cookie 通常包含标识符、站点名称以及一些号码和字符。借助于 Cookie，网站和移动设备能够存储您之前使用产品和服务时，产生的一些通用数据及其他数据。深大文德不会将 Cookie 用于本协议策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookie。您可以清除移动设备上保存的所有 Cookie。
      　　（二）日志与位置信息
      　　为了提升用户体验，我们可能会自动收集日志信息和位置信息。深大文德不会将这些信息用于本协议所述目的之外的任何用途。
      　　日志信息包括：1.设备或软件信息，例如您的移动设备、网页浏览器或您用于接入深大文德服务的其他程序所提供的配置信息、您的IP地址、无线网络接入信息和您的移动设备所用的版本和设备识别码；2.您在设备上曾使用的移动应用（APP）和其他软件的信息。
      位置信息仅在美德少年APP注册时收集一次，目的是提升用户体验，不用用户手动输入位置，如果您不同意，则需要手动输入位置信息，但不会对后续任何服务造成影响。
      
      三、深大文德如何共享您的个人信息
      　　深大文德不会与其他任何公司、组织和个人分享您的个人信息，但以下情况除外：
      　　1．在获得您的明确同意或授权后，深大文德会与其他方共享您的个人信息。
      　　2．深大文德可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。
      　　3．为实现隐私条款声明的目的，或为向您提供服务之必须，深大文德会与关联公司、合作伙伴共享您的某些个人信息。深大文德只会共享必要的个人信息，且深大文德合作伙伴和关联公司无权将共享的个人信息用于任何其他用途。同时，深大文德会与其签署保密协定，要求他们按照深大文德的说明、本隐私条款以及其他任何相关的保密和安全措施来处理个人信息。
      4．根据法律法规和商业惯例，在合并、收购、资产转让等类似交易中，如涉及到个人信息转让，深大文德会要求新的持有您个人信息的公司、组织继续受本隐私条款的约束，否则深大文德将要求该公司、组织重新向您征求授权同意。
      
      四、深大文德如何保护您的个人信息
      　　（一）深大文德已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权的访问、公开披露、使用、修改、损坏或丢失。深大文德会采取一切合理可行的措施，保护您的个人信息。例如：深大文德会使用加密技术确保数据的保密性；深大文德会使用受信赖的保护机制防止数据遭到恶意攻击；深大文德会部署访问控制机制，确保只有授权人员才可访问个人信息；以及深大文德会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
      　　（二）请您理解，由于技术水平局限以及可能存在的恶意攻击，有可能出现深大文德无法合理预见、防范、避免、控制的意外情况。互联网并非绝对安全的环境，请使用复杂密码，协助深大文德保证您的账号安全。
      （三）如发生个人信息安全事件，深大文德将按照法律法规的要求，及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，或采取合理、有效的方式发布公告。同时，深大文德还将依据监管规定，上报个人信息安全事件处置情况。
      
      五、您控制个人信息的权利
      　　按照中国相关的法律法规和监管规定，深大文德保障您对自己的个人信息行使以下权利：
      　　（一）访问、更正及更新您的个人信息
      　　您有权通过深大文德的产品，《美德少年》和《美德少年家长端》更改您的个人信息。
      　　（二）删除您的个人信息
      　　在以下情形中，您可以向深大文德提出删除个人信息的请求：
      　　1.如果深大文德处理个人信息的行为违反法律法规;
      　　2.如果深大文德收集、使用您的个人信息，却未征得您的同意；
      　　3.如果深大文德处理个人信息的行为违反了与您的约定。
      　　（三）拒绝深大文德商业广告
      　　您有权拒绝接收或退订深大文德基于个人信息向您推送的商业广告。
      　　（四）响应您的上述请求
      　　为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。深大文德可能会先要求您验证自己的身份，然后再处理您的请求。请您理解，对于某些无端重复、需要过多技术手段、给他人合法权益带来风险或者非常不切实际的请求，深大文德可能会予以拒绝。
      　　尽管有上述约定，但按照法律法规要求，如涉及以下情形深大文德将可能无法响应您的请求：
      　　1．与国家安全、国防安全相关的；
      　　2．与公共安全、公共卫生、重大公共利益相关的；
      　　3．与犯罪侦查、起诉、审判和判决执行等相关的；
      　　4．有充分证据表明您存在主观恶意或滥用权利的；
      　　5．响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；
      6．涉及深大文德商业秘密的。
      
      六、本协议如何更新
      根据国家法律法规变化及服务运营需要，深大文德将对本协议及相关规则不时地进行修改，修改后的内容会通过深大文德官网文德少年公社，美德少年APP、美德少年家长端APP等渠道公布，公布后即生效，并取代此前相关内容。您应不时关注相关公告、提示信息及协议、规则等相关内容的变动。您知悉并确认，如您不同意更新后的内容，应立即停止使用相应服务，并注销相关的用户，深大文德将停止收集您的相关个人信息；如您继续使用服务，即视为同意接受变动内容。
      
      七、如何联系深大文德
      　　如果您对本《隐私条款》有任何疑问、意见或建议，请联系深大文德客服，QQ：3564258684。
      　　请您在勾选“同意”之前仔细阅读本《隐私条款》，确保对其内容的含义及相应法律后果已全部知晓并充分理解。您勾选“同意”并完成注册程序即视为您接受本《隐私条款》，深大文德将按照相关法律法规及本政策来合法使用和保护您的个人信息。
      
       `,
      userAgreement:`深大文德教育科技（深圳）有限公司用户协议
      
深大文德教育科技（深圳）有限公司（以下简称“深大文德”）在此特别提醒您（用户）在注册成为用户之前，请认真阅读本《用户协议》（以下简称“协议”），确保您充分理解本协议中各条款。请您审慎阅读并选择接受或不接受本协议。除非您接受本协议所有条款，否则您无权注册、登录或使用本协议所涉服务。您的下载、安装、注册、登录、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。
本协议约定深大文德与用户之间关于“深大文德”旗下移动应用：美德少年软件和美德少年家长端软件服务（以下简称“服务”）的权利义务。“用户”是指注册、登录、使用本服务的个人。本协议可由深大文德随时更新，更新后的协议条款一旦公布即代替原来的协议条款，恕不再另行通知，用户可在网站和移动应用中查阅最新版协议条款。在深大文德修改协议条款后，如果用户不接受修改后的条款，请立即停止使用深大文德提供的服务，用户继续使用深大文德提供的服务将被视为接受修改后的协议。

一、协议的范围
本协议是你与深大文德之间关于你下载、安装、使用、复制本软件，以及使用深大文德相关服务所订立的协议。
   本服务中美德少年软件和美德少年家长端软件可能提供包括但不限于iOS、Android等多个应用版本，用户必须选择与所安装终端设备相匹配的软件版本。
深大文德给予你一项个人的、不可转让及非排他性的许可，以使用美德少年软件或美德少年家长端软件。你可以为非商业目的在单一台终端设备上安装、使用、显示、运行本软件。
    你可以为使用本软件及服务的目的复制本软件的一个副本，仅用作备份。备份副本必须包含原软件中含有的所有著作权信息。
     本条及本协议其他条款未明示授权的其他一切权利仍由深大文德保留，你在行使这些权利时须另外取得深大文德的书面许可。深大文德如果未行使前述任何权利，并不构成对该权利的放弃。

二、软件的获取
你可以直接从深大文德的网站（www.neccc.cn）上获取本软件，也可以从得到深大文德授权的第三方获取。
如果你从未经深大文德授权的第三方获取本软件或与本软件名称相同的安装程序，深大文德无法保证该软件能够正常使用，并对因此给你造成的损失不予负责。

三、软件的安装与卸载
深大文德可能为不同的终端设备开发了不同的软件版本，你应当根据实际情况选择下载合适的版本进行安装。下载安装程序后，你需要按照该程序提示的步骤正确安装。为提供更加优质、安全的服务，在安装深大文德的软件时，深大文德可能推荐你安装其他软件，你可以选择安装或不安装。
如果你不再需要使用深大文德的软件或者需要安装新版软件，可以自行卸载。如果你愿意帮助深大文德改进产品服务，请告知卸载的原因。

四、软件的更新
    为了改善用户体验、完善服务内容，深大文德将不断努力开发新的服务，并为你不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。为了保证本软件及服务的安全性和功能的一致性，深大文德有权不经向你特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。
本软件新版本发布后，旧版本的软件可能无法使用。深大文德不保证旧版本软件继续可用及相应的客户服务，请你随时核对并下载最新版本。

五、用户个人信息保护
    保护用户个人信息是深大文德的一项基本原则，深大文德将会采取合理的措施保护用户的个人信息。深大文德对相关信息采用专业加密存储与传输方式，保障用户个人信息的安全。
    你在注册帐号或使用本服务的过程中，需要提供一些必要的信息，例如：在美德少年家长端中，为向你提供帐号注册服务或进行用户身份识别，需要你填写手机号码。若你提供的信息不完整，则无法使用本服务或在使用过程中受到限制。
一般情况下，你可随时浏览、修改自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，你可能无法修改注册时提供的初始手机号码及其他验证信息。  
未经你的同意，深大文德不会向深大文德以外的任何公司、组织和个人披露你的个人信息，但法律法规另有规定的除外。
    对于美德少年软件和美德少年家长端软件会如何收集、使用、存储和保护你的个人信息及你享有何种权利，你还可以阅读《隐私条款》予以进一步了解。

六、主权利义务条款
美德少年和美德少年家长端的帐号的所有权归深大文德公司所有，用户完成申请注册手续后，仅获得美德少年和美德少年家长端帐号的使用权，且该使用权仅属于初始申请注册人。同时，初始申请注册人不得借用、租用或售卖美德少年和美德少年家长端帐号。
    用户有责任妥善保管注册帐户信息及帐户密码的安全，用户需要对注册帐户以及密码下的行为承担法律责任。用户同意在任何情况下不向他人透露帐户及密码信息。当在你怀疑他人在使用你的帐号时，你应立即通知深大文德公司。
你理解并同意：为了向你提供有效的服务，美德少年和美德少年家长端软件会利用你终端设备的处理器和带宽等资源。本软件使用过程中可能产生数据流量的费用，用户需自行向运营商了解相关资费信息，并自行承担相关费用。
你理解并同意：本软件的某些功能可能会让第三方知晓用户的信息，例如：用户的好友可以查询用户头像、名字等可公开的个人资料；用户绑定的学生或家长账号可以查看用户头像、账号、名字等信息；等等。
你理解并同意深大文德将会尽其商业上的合理努力保障你在本软件及服务中的数据存储安全，但是，深大文德并不能就此提供完全保证，包括但不限于以下情形：
1.深大文德不对你在本软件及服务中相关数据的删除或储存失败负责；
2.深大文德有权根据实际情况自行决定单个用户在本软件及服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等。你可根据自己的需要自行备份本软件及服务中的相关数据；
3.如果你停止使用本软件及服务或服务被终止或取消，深大文德可以从服务器上永久地删除你的数据。服务停止、终止或取消后，深大文德没有义务向你返还任何数据。
用户在使用本软件及服务时，须自行承担如下来自深大文德不可掌控的风险内容，包括但不限于：
1.由于不可抗拒因素可能引起的个人信息丢失、泄漏等风险；
2.用户必须选择与所安装终端设备相匹配的软件版本，否则，由于软件与终端设备型号不相匹配所导致的任何问题或损害，均由用户自行承担；
3.用户在使用本软件访问第三方网站时，因第三方网站及相关内容所可能导致的风险，由用户自行承担；
4.用户发布的内容被他人转发、分享，因此等传播可能带来的风险和责任；
5.由于无线网络信号不稳定、无线网络带宽小等原因，所引起的软件登录失败、资料同步不完整、页面打开速度慢等风险。
6.你理解并同意：在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、风暴、瘟疫等以及社会事件如战争、动乱、政府行为等。
    你理解并同意，深大文德有权决定将本软件作商业用途，包括但不限于开发、使用本软件的部分服务为第三方作推广等，深大文德承诺在推广过程中严格按照本协议约定保护你的个人信息，同时你亦可以根据系统设置选择屏蔽、拒绝接收相关推广信息。

七、用户行为规范
本条所述信息内容是指用户使用本软件及服务过程中所制作、复制、发布、传播的任何内容，包括但不限于美德少年和美德少年家长端帐号或功能帐号的头像、名字等注册信息，或发送的文字表情等信息。
你理解并同意，深大文德一直致力于为用户提供文明健康、规范有序的网络环境，你不得利用美德少年和美德少年家长端帐号或功能帐号或本软件及服务制作、复制、发布、传播如下干扰美德少年和美德少年家长端正常运营，以及侵犯其他用户或第三方合法权益的内容，包括但不限于：
1.发布、传送、传播、储存违反国家法律法规禁止的内容：
（1）违反宪法确定的基本原则的；
（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
（3）损害国家荣誉和利益的；
（4）煽动民族仇恨、民族歧视，破坏民族团结的；
（5）破坏国家宗教政策，宣扬邪教和封建迷信的；
（6）散布谣言，扰乱社会秩序，破坏社会稳定的；
（7）散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；
（8）侮辱或者诽谤他人，侵害他人合法权益的；
（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；
（10）以非法民间组织名义活动的；
（11）不符合《即时通信工具公众信息服务发展管理暂行规定》及遵守法律法规、社会主义制度、国家利益、公民合法利益、公共秩序、社会道德风尚和信息真实性等“七条底线”要求的；
（12）含有法律、行政法规禁止的其他内容的。
2.发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；
3.涉及他人隐私、个人信息或资料的；
4.发表、传送、传播骚扰、广告信息、过度营销信息及垃圾信息或含有任何性或性暗示的；
5.其他违反法律法规、政策及公序良俗、社会公德或干扰美德少年和美德少年家长端正常运营和侵犯其他用户或第三方合法权益内容的信息。
除非法律允许或深大文德书面许可，你使用本软件过程中不得从事下列行为：
1.删除本软件及其副本上关于著作权的信息；
2.对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码；
3.对深大文德拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；
4.对本软件或者本软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非深大文德经授权的第三方工具/服务接入本软件和相关系统；
5.通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；
6.通过非深大文德开发、授权的第三方软件、插件、外挂、系统，登录或使用深大文德软件及服务，或制作、发布、传播上述工具；
7.自行或者授权他人、第三方软件对本软件及其组件、模块、数据进行干扰；
8.其他未经深大文德明示授权的行为。
    你理解并同意，基于用户体验、美德少年和美德少年家长端或相关服务平台运营安全、平台规则要求及健康发展等综合因素，深大文德有权选择提供服务的对象，有权决定功能设置，有权决定功能开放、数据接口和相关数据披露的对象和范围。针对以下情形，有权视具体情况中止或终止提供本服务，包括但不限于：
1.违反法律法规或本协议规定的；
2.影响服务体验的；
3.存在安全隐患的；
4.与美德少年和美德少年家长端或其服务平台已有主要功能或功能组件相似、相同，或可实现上述功能或功能组件的主要效用的；
5.界面、风格、功能、描述或使用者体验与美德少年或美德少年家长端类似，可能造成用户认为其所使用的功能或服务来源于深大文德或经深大文德授权的；
6.违背美德少年和美德少年家长端运营原则，或不符合深大文德其他管理要求的。
你充分了解并同意，你必须为自己注册帐号下的一切行为负责，包括你所发表的任何内容、评论及点赞等行为，以及由此产生的任何后果。你应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。深大文德无法且不会对因前述风险而导致的任何损失或损害承担责任。
如果深大文德发现或收到他人举报或投诉用户违反本协议约定的，深大文德有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规主体相关帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号封禁直至注销的处罚，并公告处理结果。
    你理解并同意，深大文德有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何用户采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应独自承担由此而产生的一切法律责任。
    你理解并同意，因你违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，你应当独立承担责任；深大文德因此遭受损失的，你也应当一并赔偿。

八、知识产权声明
深大文德是美德少年软件和美德少年家长端软件的知识产权权利人。美德少年软件和美德少年家长端软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及与软件相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，深大文德享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。
    未经深大文德或相关权利人书面同意，你不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。

九、终端安全责任
    你理解并同意，美德少年软件和美德少年家长端软件同大多数互联网软件一样，可能会受多种因素影响，包括但不限于用户原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰，包括但不限于他人非法利用用户资料，进行现实中的骚扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁你的终端设备信息和数据安全，继而影响本软件的正常使用等。因此，你应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。
你不得制作、发布、使用、传播用于窃取美德少年软件和美德少年家长端软件帐号、功能帐号及他人个人信息、财产的恶意程序。
    维护软件安全与正常使用是深大文德和你的共同责任，深大文德将按照行业标准合理审慎地采取必要技术措施保护你的终端设备信息和数据安全，但是你承认和同意深大文德并不能就此提供完全保证。
    在任何情况下，你不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，并请经常留意深大文德有关防范诈骗犯罪的提示。

十、第三方软件或技术
    本软件可能会使用第三方软件或技术（包括本软件可能使用的开源代码和公共领域代码等，下同），这种使用已经获得合法授权。
    本软件如果使用了第三方的软件或技术，深大文德将按照相关法规或约定，对相关的协议或其他文件，可能通过本协议附件、在本软件安装包特定文件夹中打包、或通过开源软件页面等形式进行展示，它们可能会以“软件使用许可协议”、“授权协议”、“开源代码许可证”或其他形式来表达。前述通过各种形式展现的相关协议、其他文件及网页，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，你应当遵守这些要求。 如果你没有遵守这些要求，该第三方或者国家机关可能会对你提起诉讼、罚款或采取其他制裁措施，并要求深大文德给予协助，你应当自行承担法律责任。
    如因本软件使用的第三方软件或技术引发的任何纠纷，应由该第三方负责解决，深大文德不承担任何责任。深大文德不对第三方软件或技术提供客服支持，若你需要获取支持，请与第三方联系。

十一、其他
    你使用本软件即视为你已阅读并同意受本协议的约束。深大文德有权在必要时修改本协议条款。你可以在本软件的最新版本中查阅相关协议条款。本协议条款变更后，如果你继续使用本软件，即视为你已接受修改后的协议。如果你不接受修改后的协议，应当停止使用本软件。
    本协议签订地为中华人民共和国广东省深圳市南山区。
    本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。
    若你和深大文德之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，你同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。
    本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
    本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
(完)

  `
    }
  
  }
  


// WEBPACK FOOTER //
// ./src/api/privacy.js